import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
    providedIn: 'root',
})
export class GrupoEmailService extends GenericService {
    constructor(http: HttpClient) {
        super(http, 'grupo-emails');
    }

    getEstacoesDisponiveis(clienteId?: number): Observable<any> {
        let url = `${this.url_base}/${this.prefixo}/estacoes/disponiveis`;
        if (clienteId) {
            url += `?cliente_id=${clienteId}`;
        }
        return this.http.get<any>(url);
    }

    getClientesDisponiveis(): Observable<any> {
        return this.http.get<any>(`${this.url_base}/${this.prefixo}/clientes/disponiveis`);
    }
}
